<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <button :class="b()">
    <div :class="b('row-date-time')">
      <p :class="b('row-label', { dateTime: true })">
        {{ row.created_at }}
      </p>
    </div>

    <div :class="b('row-type')">
      <p :class="b('row-label')">
        {{ displayedType }}
      </p>
    </div>

    <div :class="b('row-amount')">
      <p
        :class="
          b('row-label', {
            deposit: row.type === 'deposit',
            withdrawal: row.type === 'withdrawal',
          })
        "
      >
        {{ displayedAmount }}
      </p>
    </div>

    <div :class="b('row-currency')">
      <p :class="b('row-label', { currency: true })">
        {{ row.coin.toUpperCase() }}
      </p>
    </div>

    <div :class="b('row-status')">
      <div :class="b('row-group')">
        <span :class="b('row-icon')" v-html="displayedSvg[row.status]" />

        <p :class="b('row-label', { status: true })">
          {{ $t(row.status) }}
        </p>
      </div>
    </div>

    <div :class="b('row-commission')">
      <p :class="b('row-label')">
        {{ displayedWallet }}
      </p>
    </div>

    <div :class="b('row-block')">
      <div :class="b('row-block-group')">
        <div :class="b('row-block-type')">
          <p :class="b('row-label')">
            {{ displayedType }}
          </p>

          <span
            :class="
              b('row-label', {
                deposit: row.type === 'deposit',
                withdrawal: row.type === 'withdrawal',
                block: true,
              })
            "
          >
            {{ row.amount }}

            <p :class="b('row-label', { currency: true })">
              {{ row.coin }}
            </p>
          </span>
        </div>

        <div :class="b('row-block-date')">
          <p :class="b('row-label', { dateTime: true })">
            {{ row.created_at }}
          </p>

          <span :class="b('row-icon')" v-html="displayedSvg[row.status]" />
        </div>
      </div>

      <div :class="b('row-block-group')">
        <div :class="b('row-block-commission')">
          <p :class="b('row-label')">
            {{ $t("Комиссия") }}
          </p>

          <p :class="b('row-label')">
            {{ row.fee }}
          </p>
        </div>
      </div>
    </div>
  </button>
</template>
